import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CheckOutService } from '../../../services/checkout.service';
import { CommonService } from '../../../services';
import { TenantResponse, DickerSelectListItem } from '../../../models/check-out.model';
import { Subject } from 'rxjs';
import { ApiResponse } from '../../../models/api-response.model';
import { first, takeUntil } from 'rxjs/operators';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';
import { CustomerService } from '../../../services/customer.service';
import { DDCustomer, UpdateCustomerSubscriptionsModel } from '../../../models/customer.model';
import { ManageService } from '../../../services/manage.service';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-associate-existing-end-user',
  templateUrl: './associate-existing-end-user.component.html',
  styleUrls: ['./associate-existing-end-user.component.css']
})
export class AssociateExistingEndUserComponent implements OnInit {

  title: string = "Associate Existing End User";
  userFormGroup: FormGroup;
  loadContent: boolean = false;
  programType: string;
  tenantId: string = '';
  companyCode: string = '';
  selectedPayment: string = '';
  paymentList: DickerSelectListItem[] = [];
  public currentUserModel: CurrentUserModel;
  user_validation_messages: any = {
    "domain": [
      { class: "domainValidate", message: "Please enter valid company domain" }
    ],
    "associateCompanyName": [
      { class: "associateCompanyNameValidate", message: "Please enter company name" }
    ],
    "associateEmail": [
      { class: "associateEmailValidate", message: "Please enter email address" }
    ]
  };
  //unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private checkOutService: CheckOutService,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonService: CommonService,
    private manageService: ManageService,
    private customerService: CustomerService,
    private authService: AuthService
  ) {
    this.userFormGroup = this.formBuilder.group({
      domain: new FormControl("", Validators.compose([Validators.required])),
      companyId: new FormControl({ value: "", disabled: true }),
      associateCompanyName: new FormControl("", Validators.compose([Validators.required])),
      associateEmail: new FormControl("", this.commonService.emailValidatorRegex()),
      associateCancelCC: new FormControl(false),
    });
  }

  async ngAfterViewInit() {
    await this.commonService.waitForElm('#levelOne');
    if (!this.commonService.isInCustiomerMenu()) {
      $('#levelOne').animate({ scrollLeft: 250 }, 400);
    } 
  }

  ngOnInit() {
    this.loadContent = false;
    this.companyCode = this.commonService.readCookie("CompanyCode");
    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(value => {
      this.programType = value.get('programType');
      this.loadContent = true;
    },
    (error: any) => {
      console.error(error);
      this.loadContent = true;
    });

    this.authService.getLoginInfo()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        (res: CurrentUserModel) => {
          this.currentUserModel = res;
        },
        (error: any) => {
          console.info(error);
        }
      );

    //this.getPaymentMehodList();
  }

  isNotValid(path: string, validation: any): void {
    if (path == "associateEmail") {
      if (this.userFormGroup.get(path).hasError("required")) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      } else if (this.userFormGroup.get(path).hasError("email")) {
        this.commonService.showValidator("." + validation[0].class, "Please enter a valid email address", "right", "error");
      }
    } else {
      if (!this.userFormGroup.get(path).valid) {
        this.commonService.showValidator("." + validation[0].class, validation[0].message, "right", "error");
      }
    }
  }

  // getPaymentMehodList() {
  //   this.checkOutService.GetDigitalWallet().takeUntil(this.ngUnsubscribe)
  //   .subscribe((value: DickerSelectListItem[]) => {
  //     this.paymentList = value;
  //   },
  //     (error: any) => {
  //       console.info(error);
  //     });
  // }

  
  selectPaymentMethod() {
    
    this.checkOutService.UpdateEBillingCustomerNo(this.selectedPayment, this.tenantId, this.programType).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((value: ApiResponse) => {
      if (value.status === true) {
        this.commonService.implementToast(value.responseMessage, "Success");
      } else {
        this.commonService.implementToast(value.responseMessage, "Error");
      }
    });
    
  }

  resetPayment() {
    this.selectedPayment = '';
    this.selectPaymentMethod();
  }

  // navigateToDigitalWallet() {
  //   this.router.navigateByUrl('/myAccount/digitalwallet?createNew=true');
  // }
  
  getTenantIdByDomain(): void {
    this.loadContent = false;
    if (this.userFormGroup.get("domain").value) {
      this.checkOutService.GetTenantIdByDomain(this.userFormGroup.get("domain").value).subscribe((res: TenantResponse) => {
        if (res.result == 'Success') {
          this.userFormGroup.get("companyId").setValue(res.tenantId);
          this.commonService.implementToast("Company ID from Microsoft found by the given Domain", "Success");
          this.loadContent = true;
        } else {
          this.commonService.implementToast(res.info, "Error");
          this.loadContent = true;
        }
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });
    } else {
      this.isNotValid("domain", this.user_validation_messages.domain);
      this.loadContent = true;
    }
  }

  associateEndUser(): void {
    if (this.userFormGroup.valid) {
      this.loadContent = false;
      this.checkOutService
        .AssociateCSPTenant(encodeURIComponent(JSON.stringify(this.userFormGroup.getRawValue())))
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(
          (res: TenantResponse | ApiResponse) => {
            if ((res as ApiResponse)?.status == false) {
              this.commonService.implementToast((res as ApiResponse)?.responseMessage, 'Error')
            } else {
              const tr = { ...(res as TenantResponse) }
              if (tr?.result == 'Success') {
                this.tenantId = tr?.tenantId;
                
                if (this.commonService.isInCustiomerMenu()) {
                  this.customerService.currentCustomerWatch.pipe(first()).subscribe((res: DDCustomer) => { 

                    const input = {
                      customerId: res.id,
                      vendorCustomerId: this.tenantId,
                      programType: 'CSP'
                    } as UpdateCustomerSubscriptionsModel

                    this.customerService.updateCustomerSubscriptions(input)
                      .pipe(takeUntil(this.ngUnsubscribe))
                      .subscribe(
                        (res: ApiResponse) => {
                          if (res?.status == true) {
                            setTimeout(() => {
                              this.manageService.backToTenentPage(this.tenantId);
                              this.customerService.refetchCustomerPrograms$.next();
                              // if (this.commonService.isInCustiomerMenu()) {
                              //   $('#levelOne').animate({ scrollLeft: $('#manage-customer').width() + $('#enroll-program').width() + 250 }, 400);
                              // } else {
          
                              //   this.router.navigate([`CSPDetailsNew/${tenantCreated?.tenantId}`], { relativeTo: this.activatedRoute.parent });
                              // }
                            }, 1000);
                          }
                        },
                        (error: any) => {
                          this.commonService.implementToast(error.responseMessage, "Error");
                        },
                        () => {
                          this.loadContent = true;
                        }
                      )
                  });
                  
                } else {
                  this.commonService.implementToast(tr?.info, "Success");
                  setTimeout(() => {
                    this.manageService.backToTenentPage(this.tenantId);
                  }, 1000);
                }
              } else {
                this.commonService.implementToast(tr?.info, "Error");
              }
            }
          },
          (error: any) => {
            this.commonService.implementToast(error, "Error");
          },
          () => {
            this.loadContent = true;
          }
        );

    } else {
      this.isNotValid("domain", this.user_validation_messages.domain);
      this.isNotValid("associateCompanyName", this.user_validation_messages.associateCompanyName);
      this.isNotValid("associateEmail", this.user_validation_messages.associateEmail);
      this.loadContent = true;
    }
  }
  
  close() {
    if (this.commonService.isInCustiomerMenu()) {
      this.customerService.backToCustomerEnrollProgramPage();
    } else {
      this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType);
      $('#levelOne').animate({ scrollLeft: 0 }, 400);
    }

  }
}
